<template>
  <section class="tour-operators">
    <div class="container">
      <div
        class="tour-operators__header flex justify-between items-center mb-4"
      >
        <h2 class="text-xl md:text-2xl text-[#222] m-0 font-bold">
          Туроператорлар
        </h2>
        <div class="tour-operators__navigation flex gap-2">
          <button
            class="tour-operators__nav-btn tour-operators__nav-btn--prev"
            @click="swiper.slidePrev()"
            :class="{ disabled: !canSlidePrev }"
          >
            <svg-icon name="left" />
          </button>
          <button
            class="tour-operators__nav-btn tour-operators__nav-btn--next w-10 h-10 rounded-full bg-[#F1F1F1] flex items-center justify-center"
            @click="swiper.slideNext()"
            :class="{ disabled: !canSlideNext }"
          >
            <svg-icon name="right" />
          </button>
        </div>
      </div>

      <swiper
        :slides-per-view="1"
        :space-between="12"
        :breakpoints="breakpoints"
        :pagination="{ clickable: true }"
        class="tour-operators__slider"
        @swiper="onSwiper"
      >
        <swiper-slide v-for="(operator, index) in operators" :key="index">
          <div
            class="tour-operators__card"
            @click="navigateToOperator(operator.id)"
          >
            <div class="tour-operators__logo">
              <img
                :src="operator.image"
                :alt="operator.name"
                class="w-full h-full object-cover"
              />
            </div>
            <div class="tour-operators__info">
              <h3 class="tour-operators__name truncate">{{ operator.name }}</h3>
            </div>
          </div>
        </swiper-slide>
      </swiper>
    </div>
  </section>
</template>

<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import { tourOperatorService } from "@/services";
import "swiper/css";
import "swiper/css/pagination";

export default {
  name: "TourOperators",
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      breakpoints: {
        320: {
          slidesPerView: 1.8,
        },
        640: {
          slidesPerView: 3.2,
        },
        1024: {
          slidesPerView: 6,
          slidesPerGroup: 1,
        },
      },
      operators: [],
      swiper: null,
      canSlidePrev: false,
      canSlideNext: true,
    };
  },
  mounted() {
    this.getTourOperators();
  },
  methods: {
    getTourOperators() {
      tourOperatorService.getTourOperators().then((response) => {
        this.operators = response.results;
        this.canSlideNext = true;
      });
    },
    onSwiper(swiper) {
      this.swiper = swiper;

      swiper.on("slideChange", () => {
        this.canSlidePrev = !swiper.isBeginning;
        this.canSlideNext = !swiper.isEnd;
      });
    },
    navigateToOperator(id) {
      this.$router.push({ name: "tour_operator_item", params: { id } });
    },
  },
};
</script>

<style scoped lang="scss">
.tour-operators {
  @apply bg-white py-2;

  &__header {
  }

  &__title {
    @apply text-[#222];
  }

  &__navigation {
    @apply flex items-center;
    button {
      @apply w-10 h-10 rounded-full bg-white flex items-center justify-center;
      @apply transition-all duration-300 bg-zinc-100;
      &.disabled {
        @apply opacity-50 cursor-not-allowed;
      }
    }
  }

  &__card {
    @apply flex flex-col border border-[#DEDEDE] rounded-xl p-6;
  }

  &__logo {
    @apply w-20 h-20 mx-auto mb-3 bg-white rounded-full overflow-hidden shadow-lg;
  }

  &__info {
    @apply text-center;
  }

  &__name {
    @apply text-[14px] text-[#222] text-base font-medium mb-1;
  }

  &__subtitle {
    @apply text-[#222] text-sm text-opacity-40;
  }

  :deep(.swiper-pagination) {
    @apply bottom-0;
  }

  :deep(.swiper-pagination-bullet) {
    @apply w-2 h-2 bg-[#F1F1F1] opacity-100;
  }

  :deep(.swiper-pagination-bullet-active) {
    @apply bg-[#05B242];
  }
}
</style>
